module.exports = __webpack_public_path__ + "static/media/Argos - Assigned Alerts - Purple.cf145c48.svg";